import { render, staticRenderFns } from "./SegmentationTester.vue?vue&type=template&id=61736c06&scoped=true&"
import script from "./SegmentationTester.vue?vue&type=script&lang=js&"
export * from "./SegmentationTester.vue?vue&type=script&lang=js&"
import style0 from "./SegmentationTester.vue?vue&type=style&index=0&id=61736c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61736c06",
  null
  
)

export default component.exports